import { render, staticRenderFns } from "./PXCreateSurveyIWAKPage.vue?vue&type=template&id=70ea004c&scoped=true"
import script from "./PXCreateSurveyIWAKPage.vue?vue&type=script&lang=js"
export * from "./PXCreateSurveyIWAKPage.vue?vue&type=script&lang=js"
import style0 from "./PXCreateSurveyIWAKPage.vue?vue&type=style&index=0&id=70ea004c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea004c",
  null
  
)

export default component.exports